import { render } from "./RouteComponent.vue?vue&type=template&id=782d3b71&ts=true"
import script from "./RouteComponent.ts?vue&type=script&lang=ts&external"
export * from "./RouteComponent.ts?vue&type=script&lang=ts&external"

import "./RouteComponent.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__